// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__A6X5B","list":"styles_list__3jkRA"};